module.exports = __webpack_public_path__ + "static/media/file-ppt.a3bf09f6.svg";